import { useEffect, useRef, useState } from "react";
import SideMenu from "../General/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { Show_Message } from "../General/Messagedialogbox";
import { API_POST, DecryptData } from "../General/Utility";
import ReportTable, {
  FinYear_String,
  Is_ValidResponse,
  Parse_Json,
  Sort_Design,
  Today_String,
  Norm_Date,
  Normalize_ReportQuery,
} from "./ReportTable";

// Reports whose data needs a party (the server runs RB_Load_GeneralPartyStatementRep for these)
const Party_Config = (RptId) => {
  switch (Number(RptId)) {
    case 94:
    case 96:
    case 97:
      return { strColName: "SuppName", ScrId: 3, VenType: 1 };
    case 95:
    case 100:
    case 101:
      return { strColName: "CustName", ScrId: 2, VenType: 4 };
    case 102:
      return { strColName: "VenName", ScrId: 50, VenType: 5 };
    case 132:
      // Expense Income Statement: rb_vw_expenseincomestatement reads supplier master parties of VenTypeId 2 and 3
      return { strColName: "SuppName", ScrId: 3, VenType: [2, 3] };
    default:
      return null;
  }
};
// Sort column / order travel in the query string (the request model is unchanged)
const Body_Of = (query) => Normalize_ReportQuery(query); // shared rule (ReportTable.js) for every report request
const Sort_Query = (query) =>
  query && query.strSortCol
    ? `?strSortCol=${encodeURIComponent(query.strSortCol)}&strSortOrder=${query.strSortOrder === "desc" ? "desc" : "asc"}`
    : "";
const Is_WHReport = (RptId) => Number(RptId) === 49 || Number(RptId) === 50;

function GeneralReports() {
  const dispatch = useDispatch();
  const _AuthParem = useSelector((state) => state.Common.Admin);
  const [iRptId, setiRptId] = useState(0);
  const [iScrId, setiScrId] = useState(0);
  const [strPartyName, setstrPartyName] = useState("");
  const [iTotalRows, setiTotalRows] = useState(0);
  const [RowPerPage, setRowPerPage] = useState(0);
  const [CurrPage, setCurrPage] = useState(1);
  const [strPartyScrColName, setstrPartyScrColName] = useState("");

  const [strFilterColName, setstrFilterColName] = useState("");
  const [strReportName, setstrReportName] = useState("General Reports");
  const [isPartyShow, setisPartyShow] = useState(false);
  const [iVenTypeId, setiVenTypeId] = useState(5);

  const [arrReportDesing, setarrReportDesing] = useState([]);
  const [arrReports, setarrReports] = useState([]);
  const [arrReportData, setarrReportData] = useState([]);
  const [arrSummarydata, setarrSummarydata] = useState([]);

  const [iBranchId, setiBranchId] = useState(0);
  const [iWHId, setiWHId] = useState(0);
  const [arrBranch, setarrBranch] = useState([]);
  const [arrWH, setarrWH] = useState([]);
  const [arrParty, setarrParty] = useState([]);
  const [IsWHdisable, setIsWHdisable] = useState(true);

  const [isPartyoption, setisPartyoption] = useState(false);

  const [strFromDate, setstrFromDate] = useState(FinYear_String(""));
  const [strToDate, setstrToDate] = useState(Today_String());
  const [IsDateFilter, setIsDateFilter] = useState(false);
  const [IsSortable, setIsSortable] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [iActiveFilters, setiActiveFilters] = useState(0);
  const [arrAppliedFilters, setarrAppliedFilters] = useState([]);
  const [arrActiveFilters, setarrActiveFilters] = useState([]); // removable filter chips (this user's filters)
  const [strFinFromDate, setstrFinFromDate] = useState("");
  const [IsPaged, setIsPaged] = useState(false);
  const [strSortCol, setstrSortCol] = useState("");
  const [strSortOrder, setstrSortOrder] = useState("asc");

  const IsMounted = useRef(true);
  const IsInitialised = useRef(false);
  const DateTimer = useRef(null); // header dates: the report is fetched 300ms after the last change
  const QueryRef = useRef(null); // the query behind the data on screen (paging / sort / export reuse it)
  const ReqSeq = useRef(0); // only the latest report request may update the screen
  const TotalRef = useRef(-1); // total rows of the result on screen (for page-only requests)
  const ListSeq = useRef(0);
  const PartySeq = useRef(0);

  useEffect(() => {
    IsMounted.current = true;
    Load_Reports("");
    return () => {
      IsMounted.current = false;
      clearTimeout(DateTimer.current);
    };
  }, []);

  const Load_Reports = async (strtxt) => {
    const iSeq = ++ListSeq.current;
    try {
      const AuthParems = await DecryptData(localStorage.jbctrlparams);
      const parems = {
        iScrId: 0,
        iPartyId: 0,
        strColName: "Report",
        strSearch: strtxt || "",
        strDBName: AuthParems.DB,
        iUserId: Number(AuthParems.User),
        iClientId: Number(AuthParems.Client),
        iRoleId: Number(AuthParems.Role),
        iBranchId: Number(AuthParems.Branch),
      };
      const res = await API_POST(`Reports/Load_Reports/`, parems, dispatch);
      if (!IsMounted.current || iSeq !== ListSeq.current) return;
      if (Is_ValidResponse(res, dispatch)) {
        setarrReports(Array.isArray(res.objEntRpt) ? res.objEntRpt : []);
        if (!IsInitialised.current) {
          // only on first load: typing in the report search must not reset the chosen branch
          IsInitialised.current = true;
          setarrBranch(Array.isArray(res.EntBranch) ? res.EntBranch : []);
          setarrWH(Array.isArray(res.EntWareHouse) ? res.EntWareHouse : []);
          setiBranchId(Number(AuthParems.Branch));
          setstrFromDate(FinYear_String(res.strFinFromDate));
          setstrFinFromDate(FinYear_String(res.strFinFromDate));
        }
      }
    } catch (e) {
      if (IsMounted.current) Show_Message(dispatch, e.message, "error");
    }
  };

  const Clear_Data = () => {
    TotalRef.current = -1;
    setIsLoading(false); // a request that is superseded without a new one must not leave "Loading"
    setarrReportData([]);
    setarrSummarydata([]);
    setiTotalRows(0);
    setRowPerPage(0);
    setCurrPage(1);
    setIsPaged(false);
  };
  const Fetch_Report = async (query, iKnownTotal) => {
    QueryRef.current = query;
    const iSeq = ++ReqSeq.current;
    setIsLoading(true);
    try {
      const parems = {
        ...Body_Of(query),
        strDBName: _AuthParem.DB,
        iUserId: Number(_AuthParem.User),
      };
      // page change with unchanged filters: send the known total so the server skips count + totals
      const IsPageOnly = Number.isInteger(iKnownTotal) && iKnownTotal >= 0;
      if (!IsPageOnly) TotalRef.current = -1; // filters changed: the old total is no longer valid
      const strQs = Sort_Query(query);
      const strUrl = IsPageOnly ? `${strQs || "?"}${strQs ? "&" : ""}iKnownTotal=${iKnownTotal}` : strQs;
      const res = await API_POST(`Reports/Load_GeneralReports/${strUrl}`, parems, dispatch);
      if (!IsMounted.current || iSeq !== ReqSeq.current) return; // a newer request is running
      if (!Is_ValidResponse(res, dispatch)) {
        Clear_Data();
        return;
      }
      const RptData = Parse_Json(res.EntReport);
      setarrReportDesing(Sort_Design(res.EntDesign));
      setarrReportData(RptData);
      if (!res.IsPageOnly) {
        setarrSummarydata(Parse_Json(res.EntSummary)); // page-only: keep the grand totals
        setarrActiveFilters(Array.isArray(res.EntActive) ? res.EntActive : []);
      }
      setstrFilterColName(res.strSearchCol || "");
      setiTotalRows(Number(res.TotalRows) || 0);
      TotalRef.current = Number(res.TotalRows) || 0;
      setRowPerPage(Number(res.RowPerPage) || 0);
      const iPage = Number(res.CurrPage) || 1;
      setCurrPage(iPage);
      QueryRef.current = { ...query, CurrtPage: iPage };
      setIsPaged(Boolean(res.IsPaged));
      setIsSortable(Boolean(res.IsSortable));
      setIsDateFilter(Boolean(res.IsDateFilter));
      setiActiveFilters(Number(res.iActiveFilters) || 0);
      setarrAppliedFilters(Array.isArray(res.EntAppliedFilters) ? res.EntAppliedFilters : []);
    } catch (e) {
      if (IsMounted.current && iSeq === ReqSeq.current) Show_Message(dispatch, e.message, "error");
    } finally {
      if (IsMounted.current && iSeq === ReqSeq.current) setIsLoading(false);
    }
  };
  const Can_Fetch = (query) => {
    if (!query || !Number(query.iRptId)) return false;
    if (Party_Config(query.iRptId) && !Number(query.iPartyId)) return false; // wait for a party
    return true;
  };
  const Refetch = (changes, iKnownTotal) => {
    const query = { ...(QueryRef.current || {}), ...changes };
    QueryRef.current = query;
    if (Can_Fetch(query)) Fetch_Report(query, iKnownTotal);
  };

  const View_Report = async (iId, strName, Branch, WH) => {
    const RptId = Number(iId);
    ReqSeq.current++; // ignore any answer still coming for the previous report
    setstrReportName(strName);
    setiRptId(RptId);
    setiPartyid(0);
    setstrPartyName("");
    setstrSortCol("");
    setstrSortOrder("asc");
    setarrReportDesing([]);
    Clear_Data();
    setarrActiveFilters([]); // chips belong to the previous report
    const IsWH = Is_WHReport(RptId);
    setIsWHdisable(!IsWH);
    const WHId = IsWH ? Number(WH) || 0 : 0;
    setiWHId(WHId);
    const query = {
      iRptId: RptId,
      iPartyId: 0,
      strPartyName: "",
      strColName: "",
      strSearch: "",
      iBranchId: Number(Branch) || 0,
      iWHId: WHId,
      CurrtPage: 1,
      dpFrom: strFromDate,
      dpTo: strToDate,
      strSortCol: "",
      strSortOrder: "asc",
    };
    QueryRef.current = query;
    if (fnOpenParty(RptId, query.iBranchId)) return;
    setisPartyShow(false);
    setisPartyoption(false);
    await Fetch_Report(query);
  };
  // kept for compatibility with the old state name
  const setiPartyid = (iParty) => {
    if (QueryRef.current) QueryRef.current = { ...QueryRef.current, iPartyId: Number(iParty) || 0 };
  };

  const Search_Report = (strtxt, strFilterCol) => {
    if (!Can_Fetch(QueryRef.current)) return;
    Refetch({ strSearch: strtxt || "", strColName: strFilterCol || "", CurrtPage: 1 });
  };
  const View_PageReport = (Page) => {
    if (!Can_Fetch(QueryRef.current)) return;
    Refetch({ CurrtPage: Number(Page) || 1 }, TotalRef.current);
  };
  const Sort_Report = (strCol) => {
    const query = QueryRef.current;
    if (!Can_Fetch(query)) return;
    const strOrder = query.strSortCol === strCol && query.strSortOrder === "asc" ? "desc" : "asc";
    setstrSortCol(strCol);
    setstrSortOrder(strOrder);
    Refetch({ strSortCol: strCol, strSortOrder: strOrder, CurrtPage: 1 });
  };
  const Date_Change = (strFrom, strTo) => {
    // the pickers follow the user at once; validation + fetch run 300ms after the last change
    setstrFromDate(strFrom);
    setstrToDate(strTo);
    clearTimeout(DateTimer.current);
    DateTimer.current = setTimeout(() => {
      if (!IsMounted.current) return;
      const strF = Norm_Date(strFrom);
      const strT = Norm_Date(strTo);
      if (!strF || !strT) return; // a date is still being typed / incomplete: keep the current data
      if (strF > strT) {
        Show_Message(dispatch, "From date cannot be after To date", "info");
        return;
      }
      if (QueryRef.current) QueryRef.current = { ...QueryRef.current, dpFrom: strF, dpTo: strT };
      if (IsDateFilter) Refetch({ dpFrom: strF, dpTo: strT, CurrtPage: 1 });
    }, 300);
  };
  const Reload_Report = () => {
    if (Can_Fetch(QueryRef.current)) Fetch_Report({ ...QueryRef.current });
  };
  const Download_Report = async () => {
    const query = QueryRef.current;
    if (!Can_Fetch(query)) return null;
    try {
      const res = await API_POST(
        `Reports/Download_GeneralReports/${Sort_Query(query)}`,
        { ...Body_Of(query), strDBName: _AuthParem.DB, iUserId: Number(_AuthParem.User) },
        dispatch
      );
      if (!Is_ValidResponse(res, dispatch)) return null;
      return {
        Data: Parse_Json(res.EntReport),
        Summary: Parse_Json(res.EntSummary),
        Design: Sort_Design(res.EntDesign),
      };
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
      return null;
    }
  };

  const fnOpenParty = (RptId, BranchId) => {
    const objParty = Party_Config(RptId);
    if (!objParty) return false;
    setstrPartyScrColName(objParty.strColName);
    setiScrId(objParty.ScrId);
    setiVenTypeId(objParty.VenType);
    setstrFilterColName("");
    setiPartyid(0);
    setstrPartyName("");
    setarrReportData([]);
    setarrReportDesing([]);
    setarrParty([]);
    setisPartyShow(true);
    setisPartyoption(true);
    Search_Party("", objParty.strColName, objParty.ScrId, objParty.VenType, BranchId);
    return true;
  };
  const Load_Warehouse = async (BranchId) => {
    const parems = {
      iUserId: Number(_AuthParem.User),
      iRoleId: Number(_AuthParem.Role),
      iClientId: Number(_AuthParem.Client),
      iBranchId: Number(BranchId),
      strDBName: _AuthParem.DB,
    };
    const res = await API_POST(`WarehouseMaster/Load_Warehouse/`, parems, dispatch);
    if (IsMounted.current && Is_ValidResponse(res, dispatch))
      setarrWH(Array.isArray(res.EntWarehouse) ? res.EntWarehouse : []);
  };
  const Branch_Onchange = async (branch) => {
    try {
      if (!branch) return;
      const BranchId = Number(branch.iBranchId);
      setiBranchId(BranchId);
      setiWHId(0);
      ReqSeq.current++;
      Clear_Data();
      // warehouses belong to a branch: always reload them
      await Load_Warehouse(BranchId);
      const query = { ...(QueryRef.current || {}), iBranchId: BranchId, iWHId: 0, CurrtPage: 1 };
      QueryRef.current = query;
      if (!Number(query.iRptId)) return;
      if (Party_Config(query.iRptId)) {
        // parties belong to a branch: choose the party again
        QueryRef.current = { ...query, iPartyId: 0, strPartyName: "" };
        fnOpenParty(query.iRptId, BranchId);
        return;
      }
      Fetch_Report(query);
    } catch (err) {
      Show_Message(dispatch, err.message, "info");
    }
  };
  const WH_Onchange = (WHId) => {
    setiWHId(Number(WHId) || 0);
    Refetch({ iWHId: Number(WHId) || 0, CurrtPage: 1 });
  };
  const View_VendoreOutstanding = async (party) => {
    if (!party) return;
    setisPartyoption(false);
    setstrPartyName(party.partyName);
    Refetch({
      iPartyId: Number(party.partyId) || 0,
      strPartyName: party.partyName || "",
      CurrtPage: 1,
    });
  };
  const Search_Party = async (SearchText, ColName, ScrId, VenType, BranchId) => {
    const iSeq = ++PartySeq.current;
    try {
      const objVenType = VenType !== undefined ? VenType : iVenTypeId;
      const arrVenType = Array.isArray(objVenType) ? objVenType : [objVenType];
      // one request per party type (report 132 lists two types); results merged, each party once
      const arrRes = await Promise.all(
        arrVenType.map((iType) =>
          API_POST(
            `PartyTrans/Search_Party`,
            {
              iScrId: ScrId !== undefined ? ScrId : iScrId,
              iPartyId: iType,
              strColName: ColName !== undefined ? ColName : strPartyScrColName,
              strSearch: SearchText || "",
              strDBName: _AuthParem.DB,
              iBranchId: Number(BranchId !== undefined ? BranchId : iBranchId),
            },
            dispatch
          )
        )
      );
      if (!IsMounted.current || iSeq !== PartySeq.current) return;
      const arrParty = [];
      const objSeen = {};
      arrRes.forEach((res) => {
        if (!Is_ValidResponse(res, dispatch) || !Array.isArray(res.EntParty)) return;
        res.EntParty.forEach((party) => {
          if (objSeen[party.partyId]) return;
          objSeen[party.partyId] = true;
          arrParty.push(party);
        });
      });
      if (arrVenType.length > 1)
        arrParty.sort((a, b) => String(a.partyName || "").localeCompare(String(b.partyName || "")));
      setarrParty(arrParty);
    } catch (err) {
      if (IsMounted.current) Show_Message(dispatch, err.message, "error");
    }
  };

  return (
    <>
      <SideMenu ScrId={86} />
      <ReportTable
        ReportData={arrReportData}
        ReportDesing={arrReportDesing}
        EntReports={arrReports}
        View_Report={View_Report}
        Load_Reports={Load_Reports}
        Search_Report={Search_Report}
        View_VendoreOutstanding={View_VendoreOutstanding}
        Search_Party={(txt) => Search_Party(txt)}
        EntSum={arrSummarydata}
        iRptId={iRptId}
        strReportName={strReportName}
        EntParty={arrParty}
        IsPartyOption={isPartyoption}
        IsParty={isPartyShow}
        Party_OptionShow={(e) => setisPartyoption(e)}
        PartyName={strPartyName}
        FilterColName={strFilterColName}
        setstrFilterColName={(e) => {
          setstrFilterColName(e);
          if (QueryRef.current) QueryRef.current = { ...QueryRef.current, strColName: e };
        }}
        IsAccounts={false}
        TotalRows={iTotalRows}
        RowPerPage={RowPerPage}
        View_PageReport={View_PageReport}
        CurrPage={CurrPage}
        IsPaged={IsPaged}
        IsSortable={IsSortable}
        strSortCol={strSortCol}
        strSortOrder={strSortOrder}
        Sort_Report={Sort_Report}
        strFromDate={strFromDate}
        strToDate={strToDate}
        IsDateFilter={IsDateFilter}
        Date_Change={Date_Change}
        Reload_Report={Reload_Report}
        Filter_Applied={() => {
          // a filter changed: the count, totals and page are no longer valid -> page 1, full reload
          if (Can_Fetch(QueryRef.current)) Refetch({ CurrtPage: 1 });
        }}
        IsLoading={IsLoading}
        iActiveFilters={iActiveFilters}
        EntAppliedFilters={arrAppliedFilters}
        EntActiveFilters={arrActiveFilters}
        strFinFromDate={strFinFromDate}
        Download_Report={Download_Report}
        arrWH={arrWH}
        arrBranch={arrBranch}
        iBranchId={iBranchId}
        iWHId={iWHId}
        Branch_Onchange={Branch_Onchange}
        setiWHId={WH_Onchange}
        IsWHdisable={IsWHdisable}
      />
    </>
  );
}

export default GeneralReports;